export default [
    {
        path: '/user/sale-target',
        props: true,
        component: () => import('@/views/User/SaleTarget'),
    },
];